export interface BookmarkPlatform {
  /** The browser's own bookmark shortcut, which saves the address bar's URL. */
  shortcut: "⌘D" | "Ctrl+D";
  /** A pointer that can drag a link onto a bookmarks bar. */
  desktop: boolean;
  share: ((data: { url: string; title: string }) => Promise<void>) | null;
  copy: (text: string) => Promise<void>;
}

const APPLE_PLATFORM = /mac|iphone|ipad|ipod/i;

interface PlatformSources {
  platform?: string;
  coarsePointer?: boolean;
  share?: Navigator["share"];
  canShare?: Navigator["canShare"];
  clipboard?: Pick<Clipboard, "writeText">;
}

export function bookmarkPlatformOf({
  platform = "",
  coarsePointer = false,
  share,
  canShare,
  clipboard,
}: PlatformSources): BookmarkPlatform {
  const shareable =
    share !== undefined &&
    (canShare === undefined || canShare({ url: "https://example.com/" }));
  return {
    shortcut: APPLE_PLATFORM.test(platform) ? "⌘D" : "Ctrl+D",
    desktop: !coarsePointer,
    share: shareable ? (data) => share(data) : null,
    copy: (text) => {
      if (!clipboard) return Promise.reject(new Error("no clipboard"));
      return clipboard.writeText(text);
    },
  };
}

function navigatorPlatform(): string {
  const data = Reflect.get(navigator, "userAgentData") as
    | { platform?: string }
    | undefined;
  return data?.platform ?? navigator.platform;
}

export function browserBookmarkPlatform(): BookmarkPlatform {
  return bookmarkPlatformOf({
    platform: navigatorPlatform(),
    coarsePointer: matchMedia("(pointer: coarse)").matches,
    share: navigator.share?.bind(navigator),
    canShare: navigator.canShare?.bind(navigator),
    clipboard: navigator.clipboard,
  });
}
